// extracted by mini-css-extract-plugin
export default {"wrapper":"EnergyManagement_wrapper__Nu548"};